import { render, staticRenderFns } from "./WebServicePayment.vue?vue&type=template&id=2702d0c4"
import script from "./WebServicePayment.vue?vue&type=script&lang=js"
export * from "./WebServicePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports